import { LaunchpadStatus } from '@dvb/common';
import { CourseTaskStatus } from '@school-manage/api/actions/tasks/tasks.types';
import { z } from 'zod';

export const TestSearchSchema = z.object({
  category: z.string().optional(),
  filter: z.string().optional(),
  status: z.nativeEnum(LaunchpadStatus).optional(),
});

export const LoginSearchSchema = z.object({
  from: z.string().catch(''),
});

export const TaskSearchSchema = z.object({
  courseUuid: z.string().optional().catch(''),
  search: z.string().optional().catch(''),
  status: z
    .nativeEnum(CourseTaskStatus)
    .optional()
    .catch(CourseTaskStatus.SUBMITTING),
});

export const OfflineSearchSchema = z.object({
  from: z.string(),
  search: z.record(z.string(), z.any()).optional(),
});
